var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgTeamAccessDenied(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 141,
    height: 141,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border)",
    d: "M95.898 73.837c13.593-13.593 13.593-35.632 0-49.225-13.593-13.593-35.632-13.593-49.225 0-13.593 13.594-13.593 35.632 0 49.225 13.593 13.593 35.632 13.593 49.225 0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-base)",
    d: "M91.346 69.286c11.079-11.08 11.079-29.043 0-40.122-11.08-11.08-29.043-11.08-40.123 0-11.08 11.08-11.08 29.042 0 40.122 11.08 11.08 29.043 11.08 40.123 0Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "m50.407 22.54-4.938-8.345 7.5-4.437 4.969 8.375c-2.906 1.344-4.219 2-7.531 4.406Zm-2.375-7.688 2.969 5a36.685 36.685 0 0 1 4.28-2.532l-2.968-5-4.281 2.532Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m54.657 9.82-9.97 5.907c-.905.5-2 .156-2.5-.719-.468-.844-.187-1.906.626-2.438l9.969-5.906c.875-.531 2-.219 2.53.656.532.844.22 1.97-.655 2.5Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "M41.375 15.54a2.793 2.793 0 0 1 .969-3.813l9.969-5.907a2.793 2.793 0 0 1 3.812.97 2.793 2.793 0 0 1-.969 3.812l-9.968 5.906a2.739 2.739 0 0 1-3.813-.969c0 .031 0 .031 0 0ZM53.72 7.32a.882.882 0 0 0-.469.125l-9.969 5.907c-.437.25-.562.812-.312 1.25.25.437.812.562 1.25.312l9.969-5.906a.884.884 0 0 0 .343-1.219c-.156-.312-.468-.468-.812-.468ZM66.219 15.727l-.156-4.688a2.976 2.976 0 0 1 2.875-3.094l2.468-.093a2.976 2.976 0 0 1 3.094 2.875l.156 4.78c-3.968-.25-5.28-.155-8.437.22Zm5.281-6L69 9.82c-.594.032-1.094.532-1.062 1.125l.093 2.688c1.563-.125 3.125-.188 4.688-.125l-.094-2.719c0-.594-.5-1.062-1.125-1.062Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m73.532 10.758.125 3.75a35.447 35.447 0 0 0-6.563.156l-.125-3.687a2.076 2.076 0 0 1 1.969-2.125h.031l2.469-.094c1.125 0 2.062.875 2.094 2ZM40.125 36.008 36 33.57a2.99 2.99 0 0 1-1.031-4.093l1.25-2.125a2.99 2.99 0 0 1 4.094-1.032l4.031 2.407c-1.813 2.5-2.563 3.656-4.219 7.281Zm-2.281-7.719-1.25 2.125a1.105 1.105 0 0 0 .375 1.5l2.344 1.375a32.266 32.266 0 0 1 2.343-4.031l-2.312-1.375a1.122 1.122 0 0 0-1.5.406Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "M43 28.977a34.143 34.143 0 0 0-3.281 5.656L36.5 32.727c-.969-.563-1.281-1.813-.719-2.781l1.25-2.126c.563-.968 1.813-1.28 2.782-.718h.03L43 28.977Z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E6175",
    d: "m55.998 25.274 1.613-.956 1.785 3.01-1.613.956-1.785-3.01Z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m55.998 25.274 1.613-.956 1.785 3.01-1.613.956-1.785-3.01Z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E6175",
    d: "m83.159 71.062 1.612-.956 1.785 3.01-1.612.956-1.785-3.01ZM92.184 35.724l3.01-1.785.956 1.613-3.01 1.785-.956-1.613Z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m92.184 35.724 3.01-1.785.956 1.613-3.01 1.785-.956-1.613Z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E6175",
    d: "m46.425 62.868 3.01-1.785.956 1.612-3.01 1.785-.956-1.612ZM76.582 24.919l.868-3.392 1.817.465-.868 3.392-1.817-.465Z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m76.582 24.919.868-3.392 1.817.465-.868 3.392-1.817-.465Z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#5E6175",
    d: "m63.376 76.507.868-3.391 1.817.465-.868 3.391-1.817-.465ZM95.178 56.3l.465-1.817 3.392.868-.465 1.817-3.392-.868Z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "m95.178 56.3.465-1.817 3.392.868-.465 1.817-3.392-.868ZM43.584 43.119l.465-1.817 3.392.868-.465 1.817-3.392-.868Z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M68.188 51.102c-4.25-7.157-5.688-11.813-8.781-20.313l1.437-.844c5.782 6.594 9.344 10.25 13.594 17.47l-1.625.968c-.5-.844-1.563-1.094-2.406-.625-.844.469-1.094 1.562-.625 2.406l-1.594.938Zm-5.156-15.844c1.406 3.844 2.562 7.156 5.187 12.062a3.603 3.603 0 0 1 2.907-1.718c-3.063-4.688-5.594-7.47-8.094-10.344Z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M40.562 67.445C30.5 50.477 36.094 28.54 53.094 18.477c17-10.063 38.906-4.469 48.968 12.531 10.063 17 4.469 38.906-12.531 48.969-16.969 10.062-38.875 4.468-48.938-12.5-.03 0-.03 0-.03-.032ZM71.25 15.352c-18.72.031-33.875 15.218-33.844 33.906.031 18.687 15.219 33.875 33.906 33.844 18.719-.032 33.875-15.219 33.844-33.907 0-6.062-1.625-12-4.719-17.218A33.952 33.952 0 0 0 71.25 15.352Z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M73.625 47.852c-.75-1.282-2.406-1.688-3.688-.938-1.28.75-1.687 2.406-.937 3.688-4.125-6.97-5.531-11.438-8.438-19.407l.126-.062c5.437 6.25 8.78 9.719 12.937 16.719Z"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border)",
    d: "m52.625 11.008 3.938 6.687a33.908 33.908 0 0 0-5.876 3.5l-3.937-6.687 5.875-3.5Z"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--primary-border)",
    d: "M69.469 46.133a3.656 3.656 0 0 0-1.281 4.969 3.655 3.655 0 0 0 4.968 1.28 3.72 3.72 0 0 0 1.657-2.218c.5-1.937-.688-3.906-2.594-4.406-.938-.25-1.938-.125-2.75.375Z"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M69.469 46.133a3.656 3.656 0 0 0-1.281 4.969 3.655 3.655 0 0 0 4.968 1.28 3.72 3.72 0 0 0 1.657-2.218c.5-1.937-.688-3.906-2.594-4.406-.938-.25-1.938-.125-2.75.375Z"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#c)",
    d: "M89.469 59.258h37.906v55.094H89.469V59.258Z"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-medium)",
    d: "M89 59h38v71H89V59ZM14 59h75v71H14V59Z"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#d)",
    d: "M89.469 59.258v13.094l-5.719 8.343H13.625v-8.343h65.406L89.47 59.258Z"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#e)",
    d: "M89.469 73.32V59.258l10.437 13.094h27.469v8.343h-32l-5.906-7.375Z"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M90 130H13V58h77v72Zm-75.14-2.368h73.28V60.368H14.86v67.264Z"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M128 130H89V58h39v72Zm-37.162-2.368h35.324V60.368H90.838v67.264ZM21.531 117.508h15.657v5.719H21.53v-5.719Z"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-medium)",
    d: "M79.031 72.352H2l10.75-13.094h76.719L79.03 72.352Z"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M79.469 73.29H0l12.313-14.97h79.124L79.47 73.29Zm-75.5-1.876h74.594L87.5 60.195H13.187L3.97 71.415Z"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-background-medium)",
    d: "M99.906 72.352h38.844l-10.438-13.094H89.469l10.437 13.094Z"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    fill: "var(--neutral-border-medium)",
    d: "M140.688 73.29h-41.22L87.532 58.32h41.219l11.938 14.97Zm-40.313-1.876h36.406l-8.937-11.219H91.438l8.937 11.22ZM5.893 135.263l4.286-4.286 1.325 1.326-4.286 4.286-1.325-1.326ZM14.906 134.82h1.875v6.063h-1.875v-6.063ZM1.469 126.102H7.53v1.875H1.47v-1.875Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 60.547,
    x2: 73.616,
    y1: 40.872,
    y2: 40.872,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "c",
    x1: 108.422,
    x2: 108.422,
    y1: 69.233,
    y2: 114.855,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CACFDD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EEF0F1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "d",
    x1: 85.183,
    x2: 43.712,
    y1: 59.561,
    y2: 33.441,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939BA7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939BA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "e",
    x1: 89.475,
    x2: 127.369,
    y1: 69.986,
    y2: 69.986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#939BA7",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#939BA7",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "b",
    width: 1,
    height: 1,
    patternContentUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_11318_34387",
    transform: "matrix(.0016 0 0 .0016 -.168 0)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTeamAccessDenied);
export default __webpack_public_path__ + "static/media/teamAccessDenied.c9c4b331b956e0b2865f577a391f8eaf.svg";
export { ForwardRef as ReactComponent };